export enum QUERY_KEYS {
  getImportStatus = 'get-import-csv-status',
  importCsv = 'import-csv',
  importMultiInvite = 'import-multi-invite',
}
